import React from 'react';
import { Tag } from 'antd';
import { AccountDeletionRequestStatus } from '@wellverse/shared-ts';

export const STATUS_OPTIONS: { value: AccountDeletionRequestStatus; label: string }[] = [
  { value: 'pending', label: 'Pending' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
];

const statusColors: Record<AccountDeletionRequestStatus, string> = {
  pending: 'gold',
  approved: 'red',
  rejected: 'default',
};

export const StatusTag: React.FC<{ status: AccountDeletionRequestStatus }> = ({ status }) => (
  <Tag color={statusColors[status]}>{STATUS_OPTIONS.find((o) => o.value === status)?.label ?? status}</Tag>
);
